import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import SoftAccountStatusPage from './SoftAccountStatusPage';

const _mapStateToProps = (state) => ({
    usesNewStyles:
        state.authentication.featureFlags.launchAuthenticationRefactor,
});

export default withRouter(connect(_mapStateToProps)(SoftAccountStatusPage));
